import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from '../locales/en/common.json';
import enLanding from '../locales/en/landing.json';
import enClasses from '../locales/en/classes.json';
import enAuth from '../locales/en/auth.json';
import enContact from '../locales/en/contact.json';
import enProfile from '../locales/en/profile.json';
import enNotifications from '../locales/en/notifications.json';
import enEnrollment from '../locales/en/enrollment.json';

import esCommon from '../locales/es/common.json';
import esLanding from '../locales/es/landing.json';
import esClasses from '../locales/es/classes.json';
import esAuth from '../locales/es/auth.json';
import esContact from '../locales/es/contact.json';
import esProfile from '../locales/es/profile.json';
import esNotifications from '../locales/es/notifications.json';
import esEnrollment from '../locales/es/enrollment.json';

export const LOCALE_STORAGE_KEY = 'yj_locale';
export const SUPPORTED_LOCALES = ['en', 'es'];

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                common: enCommon,
                landing: enLanding,
                classes: enClasses,
                auth: enAuth,
                contact: enContact,
                profile: enProfile,
                notifications: enNotifications,
                enrollment: enEnrollment,
            },
            es: {
                common: esCommon,
                landing: esLanding,
                classes: esClasses,
                auth: esAuth,
                contact: esContact,
                profile: esProfile,
                notifications: esNotifications,
                enrollment: esEnrollment,
            },
        },
        fallbackLng: 'en',
        supportedLngs: SUPPORTED_LOCALES,
        defaultNS: 'common',
        ns: ['common', 'landing', 'classes', 'auth', 'contact', 'profile', 'notifications', 'enrollment'],
        detection: {
            order: ['localStorage'],
            lookupLocalStorage: LOCALE_STORAGE_KEY,
            caches: ['localStorage'],
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
